import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import FormGridRow from "../../../common/components/functional/formGridRow/FormGridRow";
import { FormContainer } from "../../customer/customerManagement/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { dateTimeFormat } from "../../../common/helpers/formatDateTime";
import { format } from "date-fns";
import { AnnouncementItem } from "./types";
import { ReactComponent as DeleteIcon } from "../../../common/icons/crossRed.svg";
import { ReactComponent as EditIcon } from "../../../common/icons/editGray.svg";
import { FlexVerticalAligned } from "../../../common/components/styled/styled";

type Props = {
  announcement: AnnouncementItem;
  openAnnouncement: (id: string) => void;
  onDeleteAnnouncement: (id: string, version: number) => void;
};

export const Announcement = ({
  announcement,
  openAnnouncement,
  onDeleteAnnouncement,
}: Props) => {
  const { t } = useTranslation("settings");

  return (
    <FormContainer
      sx={{
        mb: 3,
        maxWidth: "972px",
        backgroundColor: "#FAFAFB",
      }}
    >
      <Grid container gap={2}>
        <FormGridRow
          label={t("common:start")}
          children={
            <FlexVerticalAligned>
              <Grid item xs={10}>
                <Typography>
                  {format(announcement?.startAt, dateTimeFormat)}
                </Typography>
              </Grid>
              <Grid item xs={2} mb={-0.5}>
                <IconButton onClick={() => openAnnouncement(announcement.id)}>
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={() =>
                    onDeleteAnnouncement(announcement.id, announcement.version)
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </FlexVerticalAligned>
          }
          labelSize={2}
          fieldSize={8}
        />
        <FormGridRow
          label={t("common:ends")}
          children={
            <Typography>
              {format(announcement?.endAt, dateTimeFormat)}
            </Typography>
          }
          labelSize={2}
          fieldSize={8}
        />
        <FormGridRow
          label={t("settings:targetGroup")}
          children={
            <Typography>
              {announcement?.targetGroups
                .map((g) => t(`common:${g[0] + g.slice(1).toLowerCase()}`))
                .sort((a, b) => a.localeCompare(b))
                .join(", ")}
            </Typography>
          }
          labelSize={2}
          fieldSize={8}
        />
        <FormGridRow
          label={t("settings:contentFi")}
          children={
            <Typography>
              {
                announcement?.messages.find((m) => m.languageCode === "FI")
                  ?.text
              }
            </Typography>
          }
          labelSize={2}
          fieldSize={8}
        />
        <FormGridRow
          label={t("settings:contentEn")}
          children={
            <Typography>
              {
                announcement?.messages.find((m) => m.languageCode === "EN")
                  ?.text
              }
            </Typography>
          }
          labelSize={2}
          fieldSize={8}
        />
      </Grid>
    </FormContainer>
  );
};
